// 所有渠道共用的 router 模块
// 以下是共用路由文件

// 足球 [世界杯]
import footballCupRouter from '@router/football/cup_index'
const { football_FIFAWC_RouterMode, football_FIFAWCQAZ_RouterMode } =
  footballCupRouter

// 马拉松
import marathonRouter from '@router/marathon/index'
const { marathon_RouterMode } = marathonRouter

// 综合性运动会 [大运会 | 亚运会 | 奥运会]
import compreSportsMeetRouter from '@router/compreSportsMeet/index'
const {
  compreSportsMeet_WUSG_RouterMode,
  compreSportsMeet_ASG_RouterMode,
  compreSportsMeet_SOG_RouterMode,
  compreSportsMeet_AWG_RouterMode,
  compreSportsMeet_NSG_RouterMode,
  compreSportsMeet_WOG_RouterMode,
} = compreSportsMeetRouter

// 篮球 [CBA]
import basketballRouter from '@router/basketball/index'
const { basketball_CBA_RouterMode } = basketballRouter

// 羽毛球：[汤尤杯]
import badmintonRouter from '@router/badminton/index'
const { badminton_thomasAndUber_RouterMode, badminton_sudirman_RouterMode } =
  badmintonRouter

// 网球：[中国网球公开赛]
import tennisRouter from '@router/tennis/index'
const { compreSportsMeet_chinaOpen_RouterMode } = tennisRouter

// 数据海报
import dataPosterRouter from '@router/dataPoster/index'
const { dataPoster_default_RouterMode } = dataPosterRouter

// 足球 [联赛]
import footballLeagueRouter from '@router/football/league_index'
const { football_FBLCSL_RouterMode } = footballLeagueRouter

// 篮球 [杯赛]
import basketballCupRouter from '@router/basketball/cup_index'
const {
  basketball_FIBAWA_RouterMode,
  basketball_FIBAMA_RouterMode } = basketballCupRouter

// 把下面的路由 作懒加载处理

// 平台首页
const PlatfromHomeIndex = () =>
  import(/* webpackChunkName: "platfromHomeIndex" */ '@platfrom/home/index.vue')

// 404
const NotFind = () =>
  import(/* webpackChunkName: "404Page" */ '@components/base/error_page.vue')

// 上传主题大图到oss服务器
const AutoExportPngIndex = () =>
  import(
    /* webpackChunkName: "autoExportPngIndex" */ '@platfrom/autoExportPng/index.vue'
  )

const PlatfromHome_RouterMode = {
  path: '/home/index', //平台首页
  name: 'platfromHomeIndex',
  component: PlatfromHomeIndex,
  meta: {
    breadcrumb: '平台首页',
    requireLogin: false,
  },
}

const AutoExportPng_RouterMode = {
  path: '/autoExportPng/index', //将主题大图片上传oss服务器
  name: 'autoExportPngIndex',
  component: AutoExportPngIndex,
}

const NotFind404_RouterMode = {
  path: '*',
  name: 'NotFind',
  component: NotFind,
  meta: {
    title: '404',
  },
}

export default {
  PlatfromHome_RouterMode,
  AutoExportPng_RouterMode,
  NotFind404_RouterMode,
  football_FIFAWC_RouterMode,
  football_FIFAWCQAZ_RouterMode,
  marathon_RouterMode,
  compreSportsMeet_WUSG_RouterMode,
  compreSportsMeet_ASG_RouterMode,
  compreSportsMeet_SOG_RouterMode,
  compreSportsMeet_AWG_RouterMode,
  compreSportsMeet_NSG_RouterMode,
  compreSportsMeet_WOG_RouterMode,
  basketball_CBA_RouterMode,
  badminton_thomasAndUber_RouterMode,
  compreSportsMeet_chinaOpen_RouterMode,
  dataPoster_default_RouterMode,
  football_FBLCSL_RouterMode,
  badminton_sudirman_RouterMode,
  basketball_FIBAWA_RouterMode,
  basketball_FIBAMA_RouterMode,
}
